import { render, staticRenderFns } from "./NewStock.vue?vue&type=template&id=eab33536&scoped=true&"
import script from "./NewStock.vue?vue&type=script&lang=js&"
export * from "./NewStock.vue?vue&type=script&lang=js&"
import style0 from "./NewStock.vue?vue&type=style&index=0&id=eab33536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab33536",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
